module.exports = __webpack_public_path__ + "img/italy-leukaemia-male.b249578d.png";